"use client";

import { c as _c } from "react/compiler-runtime";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import als1 from "@public/images/carousel/als1.jpg";
import als2 from "@public/images/carousel/als2.jpg";
const Carousel = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box sx={{
      width: "100%",
      height: "100vh",
      overflowY: "auto"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Carousel;